import { SideNav as SharedSidenav } from '@openx/components-core/lib/SideNav/SideNav.tsx';
import { RouterMethod } from '@openx/utils/routes/navTypes.ts';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router';

import { useRoutes } from '../../navRoutes.tsx';

const openInNewTab = (url: string): void => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');

  if (newWindow) newWindow.opener = null;
};

export const Sidenav = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const routes = useRoutes(t);
  const [_, searchParams] = useSearchParams();

  const handleNavItemClick = useCallback(
    (path: string, method: RouterMethod) => {
      if (path.includes('packages')) {
        searchParams({});
      }

      if (method === RouterMethod.external) {
        openInNewTab(path);
        return;
      }

      if (method === RouterMethod.crossApp) {
        window.location.assign(path);
        return;
      }

      document.getElementById('dashboard-content')?.scrollTo({
        top: 0,
        left: 0,
      });

      navigate(path);
    },
    [navigate, searchParams]
  );

  return <SharedSidenav routes={routes} onNavItemClick={handleNavItemClick} activeIndicatorEnabled={true} />;
};
